module.exports = __webpack_public_path__ + "static/media/ReCap.eee72c17.png";